// 🔹 Stylesheets
import * as styles from './Button.module.css';

// 🔹 React Core
import React, { CSSProperties, memo, ReactNode } from 'react';

type Props = {
  children: ReactNode;
  onClick?: any;
  variant?: 'primary' | 'secondary' | 'light' | 'outline';
  icon?: string;
  iconWidth?: number;
  className?: string;
  disabled?: boolean;
  isLoading?: boolean;
  svg?: any;
  style?: CSSProperties;
  type?: 'button' | 'submit' | 'reset';
};

export const Button = memo(
  ({
    className,
    disabled,
    isLoading,
    children,
    onClick,
    variant = 'primary',
    icon,
    iconWidth = 24,
    svg,
    style,
    type = 'button',
  }: Props) => {
    return (
      <button
        type={type}
        disabled={disabled || isLoading}
        style={style}
        className={`${
          variant === 'primary'
            ? `${styles.primary} primary-button`
            : variant === 'secondary'
              ? `${styles.secondary} secondary-button`
              : variant === 'light'
                ? `${styles.light} light-button`
                : variant === 'outline'
                  ? `${styles.outline} outline-button`
                  : ''
        } ${className ?? ''} ${isLoading ? styles.loading : ''}`}
        onClick={onClick}
      >
        {isLoading && (
          <svg
            className={styles.spinner}
            width="20"
            height="20"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="3"
            strokeLinecap="round"
            strokeLinejoin="round"
          >
            <path d="M21 12a9 9 0 1 1-6.219-8.56" />
          </svg>
        )}
        {!isLoading && icon && (
          <img src={icon} className={styles.iconLeft} style={{ width: iconWidth }} alt="" />
        )}
        {!isLoading && svg && svg}
        {children}
      </button>
    );
  },
);

Button.displayName = 'Button';
